<template>
    <div>
        <div class="margin-bottom-10">
            <vButton v-if="formData.checkStatus == 2 || formData.checkStatus == 0" theme="primary" @click="hanleclick(1)">{{$t('erp.b2c.approved', { defaultValue: '审核通过' })}}</vButton>
            <vButton v-if="formData.checkStatus == 0" class="margin-left-5" theme="success" @click="hanleclick(2)">{{$t('erp.b2c.ignore_approved', { defaultValue: '忽略-暂不审核' })}}</vButton>
            <vButton v-if="formData.isError == 1" class="margin-left-5" theme="warning" @click="hanleclick(3)">{{$t('global.common.ignoreError', { defaultValue: '忽略异常' })}}</vButton>
            <vButton v-if="formData.checkStatus == 1 || formData.checkStatus == 0" class="pull-right" @click="hanleclick(4)">{{$t('erp.product.check_refused', { defaultValue: '审核驳回' })}}</vButton>
        </div>
        <compWrapper theme="primary" :title="$t('global.common.base_information', { defaultValue: '基本信息' })">
            <compFormQuery
                class="margin-layout"
                :formdata="getBase"
                :value="formData"
                placeholder="--"
            ></compFormQuery>
        </compWrapper>
        <compWrapper theme="warning" :title="$t('erp.product.product_information', { defaultValue: '产品仓库信息' })">
            <compFormQuery
                class="margin-layout"
                :formdata="getWarehouse"
                :value="formData"
                placeholder="--"
            ></compFormQuery>
        </compWrapper>
        <compWrapper theme="info" :title="$t('erp.product.internation_information', { defaultValue: '头程信息' })">
            <compFormQuery
                class="margin-layout"
                :formdata="getHeadInfo"
                :value="formData"
                placeholder="--"
            ></compFormQuery>
        </compWrapper>
        <compWrapper :title="$t('erp.product.image_information',{defaultValue:'图片信息'})" theme="error">
			<compImage :imageformdata="imagedata" :alltype="'query'" ref="refcompimage"></compImage>
		</compWrapper>
        <compWrapper :title="$t('global.common.operation_history',{defaultValue:'操作历史'})" theme="gray">
            <compLog :data="logList"></compLog>
        </compWrapper>

        <vLoading size="large" fix :loading="loading"></vLoading>
         <!-- 两种弹框全局弹框 1:简便弹框包含alert和formdata -->
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-confirm="modalProps.show=false"
            @on-close="closemodalprops"
        >
            <component
                :is="modalProps.component"
                v-bind="modalProps"
                @on-close="closemodalprops"
                v-on="modalProps.on"
            />
        </compModal>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { HttpProductManage, HttpInventoryCodeMap, HttpGetBtachAllAction, HttpGetBtachYichang } from "@/service/setting";
import {
    HttpSysOpLog
} from '@/service/boss/allot';

import compImage from '../../products/compimage';
import mixin from "./mixin";
export default {
    props: ["params"],
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("@components/templates/log"),
		compImage,
    },
    mixins: [mixin],
    data() {
        return {
            formData: {},
            loading: false,
            modalProps:{},
            imagedata:{},
            logList:[],
        };
    },
    created() {
        this.getDetail();
    },
    computed: {
        ...mapGetters("common", ["getProductsSizeList"]),
        // ...mapGetters('dictionary', ['getCusproductList']),
        ...mapGetters("diction", ["getNewDifferentAllProductList"]),
        getBase() {
            // const packages = this.formData.packages;
            return [
                {
                    label: this.$t("global.common.auditstatus", {
                        defaultValue: "审核状态",
                    }),
                    key: "checkStatus",
                    tag: 'vSelect',
                    options:this.getCheckStatus,
                },
                {
                    label: this.$t("erp.product.audit_date", {
                        defaultValue: "审核通过日期",
                    }),
                    key: "checkTime",
                },
                {
                    label: this.$t("global.common.sku", {
                        defaultValue: "SKU",
                    }),
                    key: "erpSku",
                },
                {
                    label: this.$t("global.common.status", {
                        defaultValue: "状态",
                    }),
                    key: "enable",
                    options: this.getProductStatus,
                },
                {
                    label: this.$t('erp.product.customise_product_code', { defaultValue: '自定义产品编码' }),
                    key: 'erpSkuCode'
                },
                {
                    label: this.$t("global.common.project", {
                        defaultValue: "项目",
                    }),
                    key: "lineId",
                    options: this.getNewDifferentAllProductList,
                },
                {
                    label: this.$t("erp.setting.goods_type", {
                        defaultValue: "产品类型",
                    }),
                    key: "productType",
                    options: this.getProductType,
                },
                {
                    label: this.$t("erp.setting.goods_nameEn", {
                        defaultValue: "品名(英文)",
                    }),
                    key: "nameEn",
                },
                {
                    label: this.$t("erp.setting.goods_name", {
                        defaultValue: "品名(中文)",
                    }),
                    key: "name",
                },
                {
                    label: this.$t("erp.setting.goods_size", {
                        defaultValue: "单品包装尺寸(inch)",
                    }),
                    key: "size",
                    valueText: this.formData.length
                        ? `${this.formData.length}*${this.formData.width}*${this.formData.height}`
                        : "",
                },
                {
                    label: this.$t("erp.setting.goods_weight", {
                        defaultValue: "毛重(lb)",
                    }),
                    key: "weight",
                },
                {
                    label: this.$t("erp.setting.goods_packedsize", {
                        defaultValue: "外箱尺寸(inch)",
                    }),
                    key: "boxsize",
                    valueText: this.formData.packedLength
                        ? `${this.formData.packedLength}*${this.formData.packedWidth}*${this.formData.packedHeight}`
                        : "",
                },
                {
                    label: this.$t("erp.setting.goods_packedweight", {
                        defaultValue: "外箱毛重(lb)",
                    }),
                    key: "packedWeight",
                },
                {
                    label: this.$t("erp.setting.goods_packedcount", {
                        defaultValue: "装箱入数",
                    }),
                    key: "cartonPackedQty",
                },
                {
                    label: this.$t("erp.setting.goods_size_1", {
                        defaultValue: "商品Size",
                    }),
                    key: "packingSizeType",
                    options: this.getProductsSizeList.map((item, index) => {
                        return { value: index, label: item.label };
                    }),
                },
                {
                    label: this.$t("erp.setting.fobPrice", {
                        defaultValue: "FOB（美元）",
                    }),
                    key: "fobPrice",
                },
                {
                    label: this.$t("erp.setting.inventory", {
                        defaultValue: "库存量",
                    }),
                    key: "inventory",
                },
                {
                    label: this.$t("erp.setting.goods_UPC", {
                        defaultValue: "UPC",
                    }),
                    key: "upc",
                },
                {
                    label: this.$t("erp.setting.country_of_origin", { defaultValue: "原产地" }),
                    key: "countryOfOrigin"
                },
                {
                    label: this.$t("erp.setting.goodsstatus", { defaultValue: "产品状况" }),
                    key: "productMidCondition"
                },
            ];
        },
        getWarehouse () {
            return [
                {
                    label: this.$t("erp.setting.goods_packingType", {
                        defaultValue: "发货包装类型",
                    }),
                    key: "packingType",
                },
                {
                    label: this.$t("erp.setting.goods_isInsurance", {
                        defaultValue: "快递保价",
                    }),
                    key: "isInsurance",
                    options: this.getIsInsurance,
                },
                {
                    label: this.$t("erp.product.insured_price", {
                        defaultValue: "投保金额"
                    }),
                    key: "insuranceRate",
                },
                {
                    label: this.$t("erp.setting.goods_returntype", {
                        defaultValue: "客退处理方式",
                    }),
                    key: "returnDealMethod",
                    options: this.getReturnDealMethod,
                },
                {
                    label: this.$t("erp.setting.goods_signwervice", {
                        defaultValue: "是否需要签收服务",
                    }),
                    key: "isSignService",
                    options: this.getIsSignService,
                },
                {
                    label: this.$t("erp.setting.goods_code", {
                        defaultValue: "识别码",
                    }),
                    key: "depotskualias",
                },
                {
                    label: this.$t("erp.product.pick_difficulty", {
                        defaultValue: "拣货下架难度",
                    }),
                    key: "pickDifficult",
                },
                {
                    label: this.$t("erp.product.pick_tag", {
                        defaultValue: "拣货标签",
                    }),
                    key: "isVogue",
                    options: [
                        {
                            value: "0",
                            label: this.$t("erp.product.novogue", {
                                defaultValue: "非爆品",
                            }),
                        },
                        {
                            value: "1",
                            label: this.$t("erp.product.isvogue", {
                                defaultValue: "爆品",
                            }),
                        },
                    ],
                },{
                    label: this.$t("erp.product.packing_shape", {
                                defaultValue: "包装形状",
                            }),
                    key: 'shapeType',
                    tag: 'vSelect',
                    options: [{
                        value: 0,
                        label: this.$t("erp.product.cuboid", {
                                defaultValue: "长方体",
                            })
                    }, {
                        value: 1,
                        label: this.$t("erp.product.differentform", {
                                defaultValue: "异形体",
                            })
                    }]
                },
                {
                    label: this.$t("erp.product.packing_material", {
                                defaultValue: "包装材质",
                            }),
                    key: 'materialType',
                    tag: 'vSelect',
                    options: [{
                        value: 0,
                        label: this.$t("erp.product.cartons", {
                                defaultValue: "纸箱",
                            })
                    }, {
                        value: 1,
                        label: this.$t("bi.work.task_category_other", {
                                defaultValue: "其他",
                            })
                    }]
                },
                {
                    label: this.$t("erp.product.ismagnetic", {
                                defaultValue: "是否带磁",
                            }),
                    key: 'isMagnetism',
                    tag: 'vRadio',
                    options: [{
						trueValue: 1,
						label: this.$t('erp.global.yes',{defaultValue:'是'})
					}, {
						trueValue: 0,
						label: this.$t('erp.global.no',{defaultValue:'否'})
                    }],
                    valueText: this.formData.isMagnetism == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'}),
					props: {
						strict: false,
                    },
                },
                {
                    label: this.$t("erp.product.isliquid", {
                                defaultValue: "是否含液体",
                            }),
                    key: 'isLiquid',
                    tag: 'vRadio',
                    options: [{
						trueValue: 1,
						label: this.$t('erp.global.yes',{defaultValue:'是'})
					}, {
						trueValue: 0,
						label: this.$t('erp.global.no',{defaultValue:'否'})
                    }],
                    valueText: this.formData.isLiquid == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'}),
					props: {
						strict: false,
                    },
                },
                {
                    label: this.$t("erp.product.isbattery", {
                                defaultValue: "是否含电池",
                            }),
                    key: 'isContainBattery',
                    tag: 'vRadio',
                    options: [{
						trueValue: 1,
						label: this.$t('erp.global.yes',{defaultValue:'是'})
					}, {
						trueValue: 0,
						label: this.$t('erp.global.no',{defaultValue:'否'})
                    }],
                    valueText: this.formData.isContainBattery == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'}),
					props: {
						strict: false,
                    },
                },
                {
                    label: this.$t("erp.product.isfragile", {
                                defaultValue: "是否易碎",
                            }),
                    key: 'isFragile',
                    tag: 'vRadio',
                    options: [{
						trueValue: 1,
						label: this.$t('erp.global.yes',{defaultValue:'是'})
					}, {
						trueValue: 0,
						label: this.$t('erp.global.no',{defaultValue:'否'})
                    }],
                    valueText: this.formData.isFragile == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'}),
					props: {
						strict: false,
                    },
                },
                {
                    label: this.$t('erp.product.warehouse_difficulty', { defaultValue: '仓储费计费系数' }),
                    key: 'warehouseDifficult',
                    tag:'vInput',
                },
                {
                    label: "预估货值(USD)",
                    key: "estimatedPrice",
                    tag: "vInput",
                },
                {
                    label: this.$t("erp.product.warehouse_is_pallet", { defaultValue: "入库是否已打托" }),
                    key: "palletWarehousing",
                    tag: "vSelect",
                    options: this.getIsWarehousingPallet
                }
                ]
        },
        getHeadInfo () {
            return [
                {
                    label: this.$t("erp.product.packing_material", {
                                defaultValue: "外箱包装材质",
                            }),
                    tag: 'vSelect',
                    key: 'cartonMaterialType',
                    options: [{
                        value: 0,
                        label: this.$t("erp.product.cartons", {
                                defaultValue: "纸箱",
                            })
                    }, {
                        value: 1,
                        label: this.$t("bi.work.task_category_other", {
                                defaultValue: "其他",
                            })
                    }]
                },
                {
                    label: this.$t("erp.product.stacked_layers", {
                                defaultValue: "最高可堆叠层数",
                            }),
                    key: 'cartonMaxStacking',
                    required: false
                }]
        },
    },
    methods: {
        closemodalprops(){
            this.$emit('on-openCloseable');
            this.modalProps = {};
        },
        hanleclick(type){
            switch (type) {
                case 1:
                    this.modalProps = {
                        show: true,
                        alert: "success",
                        title: this.$t('erp.b2c.approved', { defaultValue: "审核通过" }),
                        width: 460,
                        params:{ids:this.params,type:1},
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('erp.productmanage.tip_reason', { defaultValue: "备注原因" }),
                                required:false,
                            }
                        ],
                        ajaxRequest:HttpGetBtachAllAction,
                        callback:()=>{
                            this.modalProps.show = false;
                            this.getDetail();
                            this.$emit('on-update');
                        }
                    }
                break;

                case 2:
                    this.modalProps = {
                        show: true,
                        alert: "warning",
                        title: this.$t('erp.b2c.ignore_approved', { defaultValue: "忽略-暂不审核" }),
                        width: 460,
                        params:{ids:this.params,type:4},
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('erp.productmanage.tip_reason', { defaultValue: "备注原因" }),
                                required:false,
                            }
                        ],
                        ajaxRequest:HttpGetBtachAllAction,
                        callback:()=>{
                            this.modalProps.show = false;
                            this.getDetail();
                            this.$emit('on-update');
                        }
                    }
                break;

                case 3:
                    this.modalProps = {
                        show: true,
                        alert: "warning",
                        title: this.$t('global.common.ignoreError', { defaultValue: "忽略异常" }),
                        width: 460,
                        params:{ids:this.params},
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('erp.productmanage.tip_reason', { defaultValue: "备注原因" }),
                                required:false,
                            }
                        ],
                        ajaxRequest:HttpGetBtachYichang,
                        callback:()=>{
                            this.modalProps.show = false;
                            this.getDetail();
                            this.$emit('on-update');
                        }
                    }
                break;

                case 4:
                    this.modalProps = {
                        show: true,
                        alert: "error",
                        title: this.$t('erp.product.check_refused', { defaultValue: "审核驳回" }),
                        width: 460,
                        params:{ids:this.params,type:2},
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('erp.productmanage.tip_reason', { defaultValue: "备注原因" }),
                                required:false,
                            }
                        ],
                        ajaxRequest:HttpGetBtachAllAction,
                        callback:()=>{
                            this.modalProps.show = false;
                            this.getDetail();
                            this.$emit('on-update');
                        }
                    }
                break;
            }
        },
        handleAllUnit() {
            if (!this.formData) return;
            const arrSize = [
                    "length",
                    "width",
                    "height",
                    "packedLength",
                    "packedWidth",
                    "packedHeight",
                ],
                arrWeight = ["weight", "packedWeight"];
            arrSize.forEach((key) => {
                this.formData[key] = this.handleUnit(
                    this.formData[key],
                    "cm",
                    "inch"
                );
            });
            arrWeight.forEach((key) => {
                this.formData[key] = this.handleUnit(
                    this.formData[key],
                    "g",
                    "lb"
                );
            });
        },
        getDetail() {
            this.loading = true;
			// 请求操作历史
            HttpSysOpLog({
                search: {
                    EQ_opDataId: this.params,
                    EQ_opModel: 'Product'
                }
            }).then(res => {
                // console.log(res.data)
                this.logList = res.data.content
            }, err => {

            })
            HttpProductManage({ id: this.params })
                .then((res) => {
                    const data = res.data || {};
                    this.loading = false;
                    this.formData = {
                        ...data.packages,
                        ...data,
                    };
                    this.formData.packages = {};
                    this.$set(this.$data, 'imagedata', data || {});

                    this.handleAllUnit();
                    this.getSkuCode();
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        //获取识别码
        getSkuCode() {
            HttpInventoryCodeMap({
                sku: this.formData.erpSku,
            })
                .then((res) => {
                    this.$set(this.formData, "depotskualias", res.data || "");
                })
                .catch((err) => {
                    // this.loading = false;
                });
        },
    },
};
</script>